import type { PlcManufacturerCodeLibrary } from "./types";

export const omronCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "omron",
  manufacturer_name: "Omron",
  codes: [
    {
      id: "omron-nx-ec-commerrtbl",
      manufacturer_id: "omron",
      series_id: "omron-nx",
      model: null,
      code: "_EC_CommErrTbl",
      code_type: "System Variable",
      title_ar: "EtherCAT slave communication error",
      description_ar: "المتغير النظامي _EC_CommErrTbl يحدد الـEtherCAT slaves اللي اكتشف الكنترولر بيها خطأ اتصال.",
      symptoms: ["Slave يطلع Error أو Offline", "الاتصال الدوري يتوقف على عقدة معينة"],
      causes: ["مشكلة كيبل أو تغذية slave", "إعداد EtherCAT غير مطابق", "العقدة نفسها بيها خطأ"],
      checks: [
        {
          step: 1,
          action: "راقب _EC_CommErrTbl داخل Sysmac Studio وحدد رقم الـslave اللي صار TRUE.",
          expected: "كل العناصر FALSE أثناء التشغيل الطبيعي.",
          faulty: "عنصر slave يبقى TRUE أو يتكرر.",
        }
      ],
      solutions: ["افحص الـslave المحدد وتغذيته وكيبل EtherCAT.", "راجع ترتيب العقد وإعداد EtherCAT بالمشروع."],
      severity: "عالية",
      source_title: "OMRON NJ/NX-series EtherCAT / Motion Control documentation",
      source_section: "_EC_CommErrTbl: slave communication error table",
      keywords: ["Omron", "NX", "NJ", "EtherCAT", "_EC_CommErrTbl"],
    },
    {
      id: "omron-nx-ec-netcfgerr",
      manufacturer_id: "omron",
      series_id: "omron-nx",
      model: null,
      code: "_EC_NetCfgErr",
      code_type: "System Variable",
      title_ar: "EtherCAT Network Configuration Error",
      description_ar: "المتغير _EC_NetCfgErr يدل على وجود خطأ بتكوين شبكة EtherCAT.",
      symptoms: ["EtherCAT ما يدخل بحالة تشغيل طبيعية", "أجهزة بالشبكة ما تتعرف مثل المشروع"],
      causes: ["ترتيب أو نوع slave مختلف", "Network configuration مو مطابق للواقع"],
      checks: [
        {
          step: 1,
          action: "قارن EtherCAT configuration داخل Sysmac Studio ويا الأجهزة الفعلية.",
          expected: "الترتيب والموديلات متطابقة.",
          faulty: "أكو اختلاف بالتكوين ويظل _EC_NetCfgErr فعال.",
        }
      ],
      solutions: ["صحح تكوين الشبكة أو ترتيب الأجهزة.", "سو Synchronize/compare قبل أي تنزيل جديد."],
      severity: "عالية",
      source_title: "OMRON NJ/NX-series documentation",
      source_section: "_EC_NetCfgErr diagnostic system variable",
      keywords: ["Omron", "NX", "NJ", "_EC_NetCfgErr", "network configuration"],
    },
    {
      id: "omron-nx-ec-mbxslavtbl",
      manufacturer_id: "omron",
      series_id: "omron-nx",
      model: null,
      code: "_EC_MBXSlavTbl",
      code_type: "System Variable",
      title_ar: "EtherCAT mailbox communication status",
      description_ar: "المتغير _EC_MBXSlavTbl يستخدم لمتابعة حالة mailbox communications مع EtherCAT slaves.",
      symptoms: ["Mailbox service ما يشتغل مثل المطلوب", "قراءة/كتابة إعدادات slave تفشل"],
      causes: ["Slave مو جاهز لخدمة mailbox", "اتصال EtherCAT مو مستقر", "إعداد slave غير صحيح"],
      checks: [
        {
          step: 1,
          action: "راقب حالة الـslave المطلوبة بمتغيرات EtherCAT النظامية.",
          expected: "الـslave جاهز للـmailbox communication.",
          faulty: "الـslave ما يحقق حالة الاتصال المطلوبة.",
        }
      ],
      solutions: ["عالج اتصال EtherCAT أولاً.", "راجع إعدادات وهوية الـslave."],
      severity: "متوسطة",
      source_title: "OMRON NJ/NX-series EtherCAT documentation",
      source_section: "_EC_MBXSlavTbl mailbox slave table",
      keywords: ["Omron", "EtherCAT", "_EC_MBXSlavTbl", "mailbox"],
    },
    {
      id: "omron-motion-errorid",
      manufacturer_id: "omron",
      series_id: "omron-nx",
      model: null,
      code: "ErrorID != 16#0000",
      code_type: "Motion Instruction ErrorID",
      title_ar: "Motion instruction رجعت ErrorID",
      description_ar: "بـNJ/NX motion instructions، قيمة ErrorID تحتوي كود الخطأ عند حدوث Error؛ القيمة 16#0000 تعني تنفيذ طبيعي.",
      symptoms: ["خرج Error يصير TRUE", "ErrorID يصير غير 16#0000"],
      causes: ["إعداد محور أو باراميتر غير صالح", "المحور مو بالحالة المطلوبة", "خطأ EtherCAT/servo مرتبط بالمحور"],
      checks: [
        {
          step: 1,
          action: "اقرأ Error وErrorID من الـmotion FB المتأثر.",
          expected: "Error=FALSE وErrorID=16#0000.",
          faulty: "Error=TRUE وErrorID غير 16#0000.",
        }
      ],
      solutions: ["فسر ErrorID حسب NJ/NX Motion Control Instructions Reference Manual.", "عالج حالة المحور أو الباراميتر قبل إعادة الأمر."],
      severity: "عالية",
      source_title: "OMRON NJ/NX-series Motion Control Instructions Reference / Connection Guides",
      source_section: "ErrorID output: 16#0000 = normal execution",
      keywords: ["Omron", "NX", "NJ", "motion", "ErrorID", "16#0000"],
    },
  ],
};
